//@flow
export const FLAG_STRATEGIES = {
    selectUsers: 'select_users',
    selectOrg: 'select_org',
    selectProgram: 'select_program',
};